import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'

export const useLoadSearchPresets = () => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_search_presrts'],
    queryFn: () => http.get(`/search/presets`),
    retry: false,
  })
}
